import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Icon from '~/components/common/icon';

/**
 * Render Essay Question Type
 *
 * @callback handleAnswerUpdate
 * @callback handleInputChange
 * @callback handleShowForm
 * @param {Object} props
 * @param {handleAnswerUpdate} props.handleAnswerUpdate
 * @param {handleInputChange} props.handleInputChange
 * @param {handleShowForm} props.handleShowForm
 * @param {string} props.gradedType
 * @param {string} props.gradingProgression
 * @param {boolean} props.updated
 * @param {boolean} props.showForm
 */
const QuestionTypeEssay = ( {
	handleAnswerUpdate,
	handleInputChange,
	handleShowForm,
	gradedType,
	gradingProgression,
	updated,
	showForm,
} ) => (
	<div className="ld-answer-editor">
		{ showForm ? (
			<Fragment>
				<div className="ld-answer-editor-actions -essay">
					<div className="ld-answer-group">
						<p>{ `${ LearnDashData.i18n.essay_answer_format }` }</p>

						<span className="ld-radio-input-wrapper">
							<input
								className="ld-radio-input"
								type="radio"
								id="ld-gradedtype-text"
								name="gradedType"
								checked={ 'text' === gradedType }
								onChange={ handleInputChange }
								value="text"
							/>
							<label
								className="ld-radio-input__label"
								htmlFor="ld-gradedtype-text"
							>
								<span>{ `${ LearnDashData.i18n.essay_text_answer }` }</span>
							</label>
						</span>

						<br />

						<span className="ld-radio-input-wrapper">
							<input
								className="ld-radio-input"
								type="radio"
								id="ld-gradedtype-upload"
								name="gradedType"
								checked={ 'upload' === gradedType }
								onChange={ handleInputChange }
								value="upload"
							/>
							<label
								className="ld-radio-input__label"
								htmlFor="ld-gradedtype-upload"
							>
								<span>{ `${ LearnDashData.i18n.essay_file_upload_answer }` }</span>
							</label>
						</span>
					</div>

					<div className="ld-answer-group">
						<p>{ `${ LearnDashData.i18n.essay_after_submission }` }</p>

						<span className="ld-radio-input-wrapper">
							<input
								className="ld-radio-input"
								type="radio"
								id="ld-gradedtype-not-graded-none"
								name="gradingProgression"
								checked={
									'not-graded-none' === gradingProgression
								}
								onChange={ handleInputChange }
								value="not-graded-none"
							/>
							<label
								className="ld-radio-input__label"
								htmlFor="ld-gradedtype-not-graded-none"
							>
								<span>{ `${ LearnDashData.i18n.essay_not_graded_no_points }` }</span>
							</label>
						</span>

						<br />

						<span className="ld-radio-input-wrapper">
							<input
								className="ld-radio-input"
								type="radio"
								id="ld-gradedtype-not-graded-full"
								name="gradingProgression"
								checked={
									'not-graded-full' === gradingProgression
								}
								onChange={ handleInputChange }
								value="not-graded-full"
							/>
							<label
								className="ld-radio-input__label"
								htmlFor="ld-gradedtype-not-graded-full"
							>
								<span>{ `${ LearnDashData.i18n.essay_not_graded_full_points }` }</span>
							</label>
						</span>

						<br />

						<span className="ld-radio-input-wrapper">
							<input
								className="ld-radio-input"
								type="radio"
								id="ld-gradedtype-graded-full"
								name="gradingProgression"
								checked={ 'graded-full' === gradingProgression }
								onChange={ handleInputChange }
								value="graded-full"
							/>
							<label
								className="ld-radio-input__label"
								htmlFor="ld-gradedtype-graded-full"
							>
								<span>{ `${ LearnDashData.i18n.essay_graded_full_points }` }</span>
							</label>
						</span>
					</div>
				</div>

				<div className="ld-answer-editor-actions">
					<button
						className="is-button is-primary"
						onClick={ handleAnswerUpdate }
					>{ `${ LearnDashData.i18n.update_answer }` }</button>
					<span className="ld-trash">
						<button
							className="is-button components-button is-default"
							onClick={ handleShowForm }
						>{ `${ LearnDashData.i18n.cancel }` }</button>
					</span>
					{ updated && (
						<span className="ld-answer-updated">{ `${ LearnDashData.i18n.answer_updated }` }</span>
					) }
				</div>
			</Fragment>
		) : (
			<button
				className="ld-answer-read-only -essay ld-button-reset"
				onClick={ handleShowForm }
			>
				<div className="ld-answer-editor-actions -essay">
					<div className="ld-answer-essay-settings ld-answer-group">
						<p>
							<strong>{ `${ LearnDashData.i18n.essay_answer_format }` }</strong>
						</p>
						{ 'text' === gradedType
							? `${ LearnDashData.i18n.essay_text_answer }`
							: `${ LearnDashData.i18n.essay_file_upload_answer }` }
					</div>
					<div className="ld-answer-essay-settings ld-answer-group">
						<p>
							<strong>{ `${ LearnDashData.i18n.essay_after_submission }` }</strong>
						</p>
						{ ( () => {
							switch ( gradingProgression ) {
								case 'not-graded-none':
									return `${ LearnDashData.i18n.essay_not_graded_no_points }`;
								case 'not-graded-full':
									return `${ LearnDashData.i18n.essay_not_graded_full_points }`;
								case 'graded-full':
									return `${ LearnDashData.i18n.essay_graded_full_points }`;
								default:
									return `${ LearnDashData.i18n.essay_not_set }`;
							}
						} )() }
					</div>
				</div>
				<div style={ { paddingTop: '10px' } }>
					{ `${ LearnDashData.i18n.edit_answer_settings }` }{ ' ' }
					<Icon icon="pencil" />
				</div>
				<span className="screen-reader-text">{ `${ LearnDashData.i18n.edit }` }</span>
			</button>
		) }
	</div>
);

/**
 * Valid props
 */
QuestionTypeEssay.propTypes = {
	handleShowForm: PropTypes.func,
	handleAnswerUpdate: PropTypes.func,
	handleInputChange: PropTypes.func,
	gradedType: PropTypes.string,
	gradingProgression: PropTypes.string,
	updated: PropTypes.bool,
	showForm: PropTypes.bool,
};

export default QuestionTypeEssay;
